import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * POST API call using Axios
 */

export const printApi = async (
  osdNumber: string | undefined,
  params: any = {}
) => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.PRINT);
    // Add dynamic OSD-Exception-Number
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber,
    };
    const response = await axios.post(
      getUrl(ApiType.PRINT).replace(":osdNumber", osdNumber ?? ""),
      params,
      { headers }
    );
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.printAPIError, { badRequestOrder: "errorsFirst" });
    throw new Error(ErrorMessages.printAPIError);
  }
};
